import React, { FC, useState } from 'react'
import Autocomplete from '../autocomplete'
import useDebounce from 'src/shared/hooks/useDebounce'
import { useGetProtocolsPlaceQuery } from '../../../old-app/service/Protocol'

interface IProps {
	value: any
	placeholder?: string
	onChange: (value: any) => void
	isIds?: boolean
	multiple?: boolean
}

const PlacesChoice: FC<IProps> = (p) => {
	const { value, onChange, placeholder = 'Место проведения', isIds, multiple = false } = p

	const [search, setSearch] = useState<string>('')
	const debounceSearch = useDebounce(search, 300)

	const { data: projectTemplatesData } = useGetProtocolsPlaceQuery({ name: debounceSearch })

	const list: any[] = projectTemplatesData?.data ?? []

	const onInputChange = (event: React.SyntheticEvent, value: string, reason: string) => {
		setSearch(value)
	}

	return (
		<Autocomplete
			multiple={multiple}
			placeholder={placeholder}
			// TODO: Вынести в отдельную функцию
			optionLabel={(option: any) => option?.Place}
			renderOptionLabel={(option: any) => option?.Place}
			list={list}
			onInputChange={onInputChange}
			value={value}
			onChange={onChange}
		/>
	)
}

export default PlacesChoice
